import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import type { WritableComputedRef } from 'vue'
import { NOOP, initAliveStoreIds, kapixContext, remove } from 'kapix-components-vue3'
import pFormationSectionBleuComponentStoreCustom from './store.custom'

const storeName = 'pFormationSectionBleuComponent'
const customImplement: CustomStoreImplementationOptions = pFormationSectionBleuComponentStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function pFormationSectionBleuComponentFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        $parentPage: NOOP,
        $parentComponent: NOOP,
        // Constants,
        $constants: {},
        // Data,
        $data: {
          paragraph: undefined as Nullable<string>,
          title: undefined as Nullable<string>,
          picture: undefined as Nullable<string | File>
        },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      /* @ts-ignore: to allow override in your custom file */
      $paragraph (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.paragraph,
          set: (value) => {
            this.$data.paragraph = value
            this.$emit('update:paragraph', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $title (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.title,
          set: (value) => {
            this.$data.title = value
            this.$emit('update:title', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $picture (): WritableComputedRef<Nullable<string | File>> {
        return computed({
          get: () => this.$data.picture,
          set: (value) => {
            this.$data.picture = value
            this.$emit('update:picture', value)
          }
        })
      },
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return pFormationSectionBleuComponentFactory(storeId)()
}

export const pFormationSectionBleuComponentRaw = pFormationSectionBleuComponentFactory()
export const pFormationSectionBleuComponent = () => pFormationSectionBleuComponentRaw() as MergeCustomStore<typeof pFormationSectionBleuComponentStoreCustom.instance>
